import { createReducer, on } from '@ngrx/store';
import { loadBusinessUserSuccess } from './businessUser.actions';
import { BusinessUser } from '@shared';

export interface BusinessUserState {
  businessUser: BusinessUser;
}

export const initialState: BusinessUserState = {
  businessUser: {
    _id: '',
    email: '',
    businessSfId: '',
    name: '',
    ownerName: '',
    phoneNumber: '',
    workArea: '',
    city: '',
    street: '',
    houseNumber: '',
    status: '',
  },
};

const _businessUSerReducer = createReducer(
  initialState,
  on(loadBusinessUserSuccess, (state, { businessUser }) => ({ ...state, businessUser })),
);

export function businessUserReducer(state: BusinessUserState | undefined, action: any) {
  return _businessUSerReducer(state, action);
}
